import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AvailabilityEntry } from '@fcom/dapi/api/models';
import { NotificationLayout } from '@fcom/ui-components';

@Component({
  selector: 'fin-seasonal-notification',
  templateUrl: './seasonal-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeasonalNotificationComponent {
  @Input() availability: AvailabilityEntry[];
  @Input() destination: string;
  @Input() origin: string;

  readonly NotificationLayout = NotificationLayout;
}
